module.exports = __webpack_public_path__ + "img/horseC.b69a111b.svg";